<template>
  <v-btn
    class="button-main-dialog font-weight-medium tw:m-0"
    :class="{ 'font--text': cancel, cancel: cancel }"
    elevation="0"
    v-on="$listeners"
    v-bind="{
      color: cancel ? undefined : color,
      ...$attrs,
    }"
  >
    {{ computedText }}
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonMainDialog',
  props: {
    small: {
      type: Boolean,
      default: true,
    },
    cancel: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    /**
     * @type {('primary'|'success'|'error')} color=primary kolor
     */
    color: {
      type: String,
      default: 'primary',
    },
    translationPath: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedText() {
      return this.text || this.$i18n.t(this.translationPath);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  &.v-btn {
    letter-spacing: 0.0178571429em !important;
    min-width: 70px !important;
    text-transform: initial;
    line-height: normal;
    &.v-size--small {
      margin-right: 16px !important;
      font-size: 11px;
      height: 27px;
      padding: 5.5px 15px;
    }
    &.v-size--default {
      margin-left: 18px !important;
      font-size: 13px;
      height: 32px;
      padding: 8px 14.5px;
    }
  }
}
</style>
